"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { isFormula } from '@membranehq/sdk';
import DataBuilderFormNestedArrayItems from './Nested/ArrayItems.mjs';
import DataBuilderFormNestedNoSchema from './Nested/NoSchema.mjs';
import DataBuilderFormNestedObjectFields from './Nested/ObjectFields.mjs';
import useDataBuilderField from './use-data-builder-field.mjs';

function DataBuilderFormNested({
  field,
  onChange
}) {
  const { localSchema } = useDataBuilderField();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !localSchema?.type && /* @__PURE__ */ jsx(DataBuilderFormNestedNoSchema, { field, onChange }),
    localSchema?.type == "object" && !isFormula(field.value) && /* @__PURE__ */ jsx(DataBuilderFormNestedObjectFields, { field, onChange }),
    localSchema?.type == "array" && /* @__PURE__ */ jsx(DataBuilderFormNestedArrayItems, { field, onChange })
  ] });
}

export { DataBuilderFormNested as default };
